// English translations
export const en = {
  // Navigation
  'nav.home': 'Home',
  'nav.profile': 'Profile',
  'nav.admission': 'Admission',
  'nav.news': 'News',
  'nav.services': 'Services',
  'nav.research': 'Research & Publications',
  'nav.search': 'Search',
  'nav.portal': 'Student Portal',
  'nav.menu': 'Menu',
  'nav.event': 'Events',
  'nav.information': 'Information',
  'nav.announcement': 'Announcements',
  'nav.bulletin': 'Bulletin',
  'nav.gallery': 'Gallery',
  'nav.ppid': 'PPID',
  'nav.researchTraining': 'Research & Training',
  'nav.seminarWebinar': 'Seminar & Webinar',
  'nav.others': 'Others',

  // Profile submenu
  'nav.about': 'About UNMUL',
  'nav.history': 'History & Vision Mission',

  // History Section
  'history.title': 'Short History',
  'history.label': 'The Beginning',
  'history.established': 'Founded Year',

  // Vision Mission Section
  'visionMission.label': 'Vision & Mission',
  'visionMission.title': 'Direction Towards',
  'visionMission.subtitle': 'The Future',
  'visionMission.vision': 'Vision',
  'visionMission.mission': 'Mission',

  // Core Values Section
  'coreValues.title': 'Core',
  'coreValues.subtitle': 'Values',
  'coreValues.description': 'Principles we uphold in implementing the Three Pillars of Higher Education',
  'coreValues.integrity': 'Integrity',
  'coreValues.integrityDesc': 'Upholding honesty and ethics in all academic and organizational aspects.',
  'coreValues.innovation': 'Innovation',
  'coreValues.innovationDesc': 'Encouraging creativity and new thinking for future challenge solutions.',
  'coreValues.collaboration': 'Collaboration',
  'coreValues.collaborationDesc': 'Building strong partnerships with various parties for mutual progress.',
  'coreValues.sustainability': 'Sustainability',
  'coreValues.sustainabilityDesc': 'Committed to environmental preservation and sustainable development.',

  'nav.structure': 'Organizational Structure',
  'nav.leadership': 'Leadership',
  'nav.campusMap': 'Campus Map',
  'nav.academic': 'Academic',
  'nav.academicInfo': 'Academic Information',
  'nav.faculties': 'Faculties',
  'nav.researchLink': 'Research & Innovation',
  'nav.studentAffairs': 'Student Affairs',
  'nav.cooperation': 'Cooperation',
  'nav.contact': 'Contact Us',

  // Admission submenu
  'nav.pmbInfo': 'Admission Information',
  'nav.snbp': 'SNBP Track',
  'nav.snbt': 'SNBT Track',
  'nav.mandiri': 'Independent Track',

  // Services submenu
  'nav.infoSystem': 'Information Systems',
  'nav.ais': 'AIS',
  'nav.elearning': 'E-Learning',
  'nav.repository': 'Repository',
  'nav.ejournal': 'E-Journal',
  'nav.studentServices': 'Student Services',
  'nav.digitalLibrary': 'Digital Library',
  'nav.scholarship': 'Scholarships',
  'nav.ukm': 'Clubs & Organizations',
  'nav.counseling': 'Student Counseling',
  'nav.generalServices': 'General Services',
  'nav.helpdesk': 'IT Helpdesk',
  'nav.correspondence': 'Online Correspondence',
  'nav.privacy': 'Privacy Policy',
  'nav.faq': 'FAQ',
  'nav.staffDosen': 'Staff & Lecturers',

  // Research submenu
  'nav.researchCenter': 'Research Centers',
  'nav.lp2m': 'LP2M',
  'nav.tropicalStudy': 'Tropical Studies Center',
  'nav.labs': 'Research Laboratories',
  'nav.haki': 'IP & Patents',
  'nav.publications': 'Scientific Publications',
  'nav.journals': 'UNMUL Journals',
  'nav.proceedings': 'Conference Proceedings',
  'nav.researchRepo': 'Research Repository',
  'nav.indexed': 'Indexed Articles',

  // Hero section
  'hero.badge': 'Leading State University in Kalimantan',
  'hero.title1': 'Mulawarman',
  'hero.title2': 'University',
  'hero.subtitle': 'Becoming a university that produces human resources with character and global competitiveness in the development of science, technology, arts and culture based on natural resources and local wisdom.',
  'hero.cta.register': 'Register Now',
  'hero.cta.explore': 'Explore Programs',
  'hero.cta.watchProfile': 'Watch Profile',
  'hero.mainTitle1': 'Building Civilization',
  'hero.mainTitle2': 'In The Heart of Nusantara',

  // Stats
  'stats.faculties': 'Faculties',
  'stats.programs': 'Study Programs',
  'stats.students': 'Active Students',
  'stats.accreditation': 'Accreditation',
  'stats.lecturers': 'Lecturers',
  'stats.alumni': 'Alumni',
  'stats.staff': 'Education Staff',
  'stats.sectionTitle': '{siteName} in Numbers',
  'stats.sectionSubtitle': 'Current data about our university',
  'stats.studentDist': 'Student Distribution',
  'stats.byProgram': 'By Program',
  'stats.staffDist': 'Lecturer Distribution',
  'stats.byRank': 'By Rank',
  'stats.studentByYear': 'Students by Year',
  'stats.yearlyDistribution': 'Yearly Distribution',

  // News Section
  'news.title': 'Campus News',
  'news.viewAll': 'View All News',
  'news.noNews': 'No recent news.',
  'news.announcement': 'Announcements',
  'news.gallery': 'Gallery',

  // Sections
  'section.news': 'News & Announcements',
  'section.newsSubtitle': 'Latest information from {siteName}',
  'section.faculties': 'Faculties',
  'section.facultiesSubtitle': 'Choose the faculty that suits your interests and talents',
  'section.admission': 'New Student Admission',
  'section.admissionSubtitle': 'Join the {siteName} family',

  // Footer
  'footer.about': '{siteName} is a leading state university in East Kalimantan, established in 1962.',
  'footer.quickLinks': 'Quick Links',
  'footer.contact': 'Contact Us',
  'footer.address': 'Jl. Kuaro, Gunung Kelua, Samarinda',
  'footer.newsletter': 'Subscribe to Newsletter',
  'footer.newsletterText': 'Get the latest news directly to your email',
  'footer.subscribe': 'Subscribe',
  'footer.rights': 'All Rights Reserved',
  'footer.aboutUs': 'About Us',
  'footer.academic': 'Academic',
  'footer.registration': 'Registration',
  'footer.researchInnovation': 'Research & Innovation',
  'footer.studentAffairs': 'Student Affairs',
  'footer.cooperation': 'Cooperation',
  'footer.contactUs': 'Contact Us',
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.terms': 'Terms & Conditions',
  'footer.sitemap': 'Sitemap',
  'footer.emailPlaceholder': 'Your Email',
  'footer.workingHours': 'Monday - Friday: 08:00 - 16:00',

  // Common
  'common.readMore': 'Read More',
  'common.viewAll': 'View All',
  'common.learnMore': 'Learn More',
  'common.submit': 'Submit',
  'common.search': 'Search...',
  'common.loading': 'Loading...',
  'common.backToHome': 'Back to Home',
  'common.pageNotFound': 'Page Not Found',
  'common.updated': 'Updated',
  'common.download': 'Download',
  'common.external': 'External Link',
  'common.allRightsReserved': 'All Rights Reserved',
  'common.journey': 'Our',
  'common.us': 'Journey',

  // Agenda Section
  'agenda.title': 'Campus Agenda',
  'agenda.subtitle': 'Latest activities and events',
  'agenda.viewAll': 'View All Events',
  'agenda.noEvents': 'No recent events.',

  // Announcement Section
  'announcement.title': 'Announcements',
  'announcement.subtitle': 'Latest important information',
  'announcement.viewAll': 'View All Announcements',
  'announcement.noAnnouncements': 'No recent announcements.',
  'announcement.label': 'ANNOUNCEMENT',

  // Rektor Section
  'rektor.name': 'Prof. Dr. Ir. H. Abdunnur, M.Si',
  'rektor.title': 'Rector of {siteName}',
  'rektor.position_dynamic': '{siteName} {role}',
  'rektor.greeting': "{role}'S WELCOME",
  'rektor.quote': '"Towards a World Class University Based on',
  'rektor.quoteHighlight': 'Tropical Studies',
  'rektor.paragraph1': 'Welcome to {siteName}. As the largest and oldest university in East Kalimantan, we bear a historical mandate to become a new center of civilization in the new Capital City, Nusantara.',
  'rektor.paragraph2': 'We are dedicated to creating an academic ecosystem that is not only excellent in science and technology but also deeply rooted in the preservation of tropical rainforests, which serve as the lungs of the world.',

  // Contact Page
  'contact.title': 'Contact Us',
  'contact.breadcrumb': 'Contact',
  'contact.hero.subtitle': 'Have questions? Do not hesitate to contact us through various available channels.',
  'contact.department.title': 'Department Contacts',
  'contact.location.title': 'Campus Location',
  'contact.address.title': 'Main Address',
  'contact.social.title': 'Social Media',
  'contact.quick.title': 'Need Quick Help?',
  'contact.whatsapp': 'Chat via WhatsApp',
  'contact.dept.rectorate': 'Rectorate',
  'contact.dept.academic': 'Academic Affairs',
  'contact.dept.student': 'Student Affairs',
  'contact.dept.finance': 'Finance Department',
  'contact.dept.pr': 'Public Relations',
  'contact.dept.admission': 'Admissions (PMB)',

  // Admission Page
  'admission.title': 'New Student Admission',
  'admission.breadcrumb': 'Admission',
  'admission.status.open': 'REGISTRATION OPEN',
  'admission.hero.title': 'New Student Admission',
  'admission.hero.subtitle': 'Make your dream come true to be part of the big family of {siteName}. Choose the entry path that suits your abilities.',
  'admission.portal': 'PMB Portal',
  'admission.viewPaths': 'View Entry Paths',
  'admission.paths.title': '{siteName} Entry Paths',
  'admission.paths.subtitle': 'Choose the registration path that best fits your profile and abilities',
  'admission.popular': 'MOST POPULAR',
  'admission.timeline': 'Timeline',
  'admission.moreInfo': 'More Info',
  'admission.steps.title': 'Registration Steps',
  'admission.cta.title': 'Have Questions?',
  'admission.cta.subtitle': 'Contact our PMB Helpdesk team for assistance with new student registration.',

  // Admission Paths & Steps
  'admission.path.snbp.title': 'National Selection Based on Achievement',
  'admission.path.snbp.desc': 'Selection without test based on academic and non-academic achievements during high school.',
  'admission.path.snbt.title': 'National Selection Based on Test',
  'admission.path.snbt.desc': 'Selection through Computer-Based Written Test (UTBK) measuring reasoning skills.',
  'admission.path.mandiri.title': 'Independent Selection',
  'admission.path.mandiri.desc': 'Independent path organized directly by {siteName}.',

  'admission.step.1.title': 'Create Account',
  'admission.step.1.desc': 'Register an account on PMB portal with active email',
  'admission.step.2.title': 'Complete Data',
  'admission.step.2.desc': 'Fill in biodata form and choose study program',
  'admission.step.3.title': 'Upload Documents',
  'admission.step.3.desc': 'Upload photo, diploma, and supporting documents',
  'admission.step.4.title': 'Payment',
  'admission.step.4.desc': 'Pay registration fee via bank/e-wallet',
  'admission.step.5.title': 'Print Card',
  'admission.step.5.desc': 'Download exam participant card',

  // Fakultas Page
  'faculties.search': 'Search faculties or study programs...',
  'faculties.breadcrumb': 'Faculties',
  'faculties.badge.count': '{count} Faculties',
  'faculties.badge.programs': '100+ Study Programs',
  'faculties.title.explore': 'Explore',
  'faculties.title.faculties': 'Faculties',
  'faculties.title.programs': 'and Study Programs',
  'faculties.subtitle': 'Find your dream study program from various education levels in 15 best faculties of {siteName}',
  'faculties.description': 'Currently, {siteName} has <strong class="text-unmulYellow">15 faculties</strong> with over <strong class="text-unmulYellow">100 study programs</strong> ranging from Diploma, Bachelor, Master, Doctoral, to Professional degrees. The faculties are:',
  'faculties.stats.faculties': 'Faculties',
  'faculties.stats.program': 'Study Programs',
  'faculties.stats.level': 'Levels',
  'faculties.stats.profession': 'Professions',
  'faculties.section.title': 'Choose',
  'faculties.section.titleHighlight': 'Your Faculty',
  'faculties.section.subtitle': 'Search and find the faculty or study program you want',
  'faculties.card.programs': '{count} Study Programs',
  'faculties.card.showAll': 'Show all',
  'faculties.card.showProdi': 'View all {count} programs',
  'faculties.card.hide': 'Hide',
  'faculties.card.visit': 'Visit Website',
  'faculties.noResults.title': 'No results found',
  'faculties.noResults.subtitle': 'Try other keywords to search for faculties or study programs',
  'faculties.noResults.reset': 'Reset Search',
  'faculties.cta.title': 'Ready to Start Your Academic Journey?',
  'faculties.cta.subtitle': 'Find the study program that suits your interests and talents. Achieve a bright future with {siteName}!',
  'faculties.cta.button': 'Registration Information',
  'faculties.cta.contact': 'Contact Us',

  // Admission Landing Section
  'admissionSection.title': '{siteName} Entry Paths {year}',
  'admissionSection.subtitle': 'Prepare yourself to become part of the big family of {siteName}.',
  'admissionSection.snbp.title': 'SNBP',
  'admissionSection.snbp.desc': 'National Selection Based on Achievement (No Test).',
  'admissionSection.snbp.item1': 'Report Card Grades Sem 1-5',
  'admissionSection.snbp.item2': 'Academic/Non-Academic Achievements',
  'admissionSection.snbp.item3': 'Portfolio (Arts/Sports)',
  'admissionSection.snbp.button': 'More Details',
  'admissionSection.snbt.title': 'SNBT',
  'admissionSection.snbt.desc': 'National Selection Based on Test (UTBK).',
  'admissionSection.snbt.item1': 'Scholastic Potential Test',
  'admissionSection.snbt.item2': 'Language Literacy',
  'admissionSection.snbt.item3': 'Mathematical Reasoning',
  'admissionSection.snbt.button': 'Check Schedule',
  'admissionSection.snbt.popular': 'MOST POPULAR',
  'admissionSection.mandiri.title': 'SMMPTN',
  'admissionSection.mandiri.desc': 'Independent Selection for State Universities.',
  'admissionSection.mandiri.item1': 'Independent Written Test',
  'admissionSection.mandiri.item2': 'Achievement Recognition Path',
  'admissionSection.mandiri.item3': 'Regional Affirmation',
  'admissionSection.mandiri.button': 'Create Account',

  // CTA Section
  'cta.title': 'Ready to Join Us?',
  'cta.subtitle': 'Be part of the next generation contributing to Indonesia from the Heart of Nusantara.',
  'cta.register': 'Register Now',
  'cta.visitCampus': 'Visit Campus',
};

export default en;

